import { connect } from 'react-redux';
import { setAgeGroup } from '../reducers/mode';
import { closeAgeSelectionModal } from '../reducers/modals';
import AgeSelectionModal from '../components/age-selection-modal/age-selection-modal.jsx';
import { AGE_GROUPS } from '../lib/layout-constants';

const mapStateToProps = state => ({
    isOpen: state.scratchGui.modals.ageSelectionModal
});

const mapDispatchToProps = dispatch => ({
    onSelect: ageGroup => {
        // Map '4+' and '7+' to the constants or pass directly
        const mode = ageGroup === '4+' ? AGE_GROUPS.JUNIOR : AGE_GROUPS.SENIOR;
        dispatch(setAgeGroup(mode));
        dispatch(closeAgeSelectionModal());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AgeSelectionModal);
